import type { Ref } from 'vue'
import { computed, ref } from 'vue'
import { useCustomerExistsQuery } from '@/graphql/api'
import type { Email } from '@/types/email'

export function useCustomerExistsLoginForm(email: Ref<Email | ''>) {
    const { fetching: fetchingCustomerExists, executeQuery } =
        useCustomerExistsQuery({
            variables: computed(() => ({
                email: email.value as Email,
            })),
            pause: true,
        })

    const showLogin = ref(false)

    const openLoginForm = () => {
        showLogin.value = true
    }

    const closeLoginForm = () => {
        showLogin.value = false
    }

    const resetEmail = () => {
        closeLoginForm()

        email.value = ''
    }

    const customerExists = async () => {
        const result = await executeQuery()

        if (result.data.value?.customerExists) {
            openLoginForm()
        }

        return result.data.value?.customerExists
    }

    return {
        fetchingCustomerExists,
        showLogin,
        closeLoginForm,
        resetEmail,
        customerExists,
    }
}
